import { type ReactNode } from 'react';
import { Outlet } from 'react-router';
import { Header } from './header';
import { HelpMenu } from './help';
import { ProfileQuiz } from '@/packages/profile-quiz';
import { FlashToast } from '@/components/flash-toast';
import { useAnalyticsIdentity } from '@/hooks/use-analytics-identity';

interface LayoutProps {
  children?: ReactNode;
  auth?: boolean;
}

export const Layout = ({ children, auth }: LayoutProps) => {
  useAnalyticsIdentity(!auth);

  return (
    <>
      {!auth && (
        <>
          <Header />
          <ProfileQuiz />
        </>
      )}
      {children ?? <Outlet />}
      <HelpMenu />
      <FlashToast />
    </>
  );
};
